<template>
	<div class="instagram-page instagram-feed">
		<div class="row">
            <div class="col-md-12">
                <span v-if="loading">Loading..</span>
                <div class="row" v-else>
                    <div class="col-md-4 instagram-post-wrapper" v-for="post in posts">
                        <instagram-post :post="post" :key="post.id" :profile-ids="profileIDs" >
                        </instagram-post>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <pagination
                :current_page="page"
                :last_page="lastPage"
                :num_items="12"
                :num_total="total"
                >
            </pagination>
        </div>
	</div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import DateRangePicker from 'vue2-daterange-picker'
    import InstagramService from '../../services/instagram-service'
    import InstagramPost from './InstagramPost'
    import InstagramMixin from "./InstagramMixin";

export default {
	components: {InstagramPost, DateRangePicker, Multiselect},
    mixins: [InstagramMixin],
	props: ['teams', 'user', 'label'],
	data: function() {
		return {
			posts: [],
            page: 1,
            lastPage: null,
            total: null,
            order: 'publishedDate',
            sort: 'desc',
		}
	},
	methods: {
	    setOrder(order) {
	        if(this.order === order) {
	            if (this.sort === 'asc') {
	                this.sort = 'desc'
                } else {
	                this.sort = 'asc'
                }
            } else {
	            this.sort = 'desc'
            }

	        this.order = order

            this.getPosts()
        },
        changePage(page) {
            this.page = page
            this.loadPosts(this.label)
        },
        async loadPosts(label = '') {

            const params = {
                filters: {},
                from: '2000-01-01',
                to: '2020-02-01',
                sortBy: this.order,
                sortOrder: this.sort
            }

            if (!this.selectedHashtags.length) {
                params.filters.hashtags = this.jwtHashtags
            } else {
                params.filters.hashtags = this.selectedHashtags
            }

            params.filters.locations = this.selectedLocations
            params.filters.profileIDs = this.selectedProfiles
            params.filters.label = label

            const posts = await InstagramService.v2.posts.index(Object.assign({}, params, {
                limit: 12,
                page: this.page
            }))

            this.posts = posts.data
            this.lastPage = posts.lastPage
            this.total = posts.total
        },
	    async getPosts(initial = false, label = '') {

            if (initial) {
                this.selectedHashtags = this.jwtHashtags
                this.selectedProfiles = this.profileIDs
            }

            const params = {
                filters: {},
                from: '2000-01-01',
                to: '2020-02-01',
                sortBy: this.order,
                sortOrder: this.sort
            }

            if (!this.selectedHashtags.length) {
                params.filters.hashtags = this.jwtHashtags
            } else {
                params.filters.hashtags = this.selectedHashtags
            }

            params.filters.locations = this.selectedLocations
            params.filters.profileIDs = this.selectedProfiles
            params.filters.label = label

            this.loading = true

            this.loadPosts(label)

            this.loading = false
        }
	},
	async mounted() {
        this.$on('change-page', (index) => {
            this.changePage(index);
        });

        var instance = this
        this.getPosts(true)
        this.$eventHub.$on('updateSocialFeed', ({label, page}) => {
            if (page != null) this.page = page
            this.getPosts(false, label)
        })
	}
}
</script>
